<app-confirm-dialog></app-confirm-dialog>

<div class="layout">
  <!-- SIDEBAR -->
  <app-sidebar [mobileOpen]="mobileSidebarOpen()" (menuSelected)="closeMobileSidebar()">
  </app-sidebar>

  <!-- CONTENIDO -->
  <div class="content">
    <!-- TOPBAR -->
    <header class="topbar">
      <!-- BOTÓN HAMBURGER PARA MÓVIL -->
      <button class="mobile-menu-btn" (click)="toggleMobileSidebar()">
        <i class="bi bi-list"></i>
      </button>

      <div class="topbar-left">
        <div class="breadcrumb-row">
          <i class="bi bi-house-door home-breadcrumb-icon"></i>

          <span class="breadcrumb-text"> > KPI Manager > {{ title() }} </span>
        </div>

        <!-- TÍTULO PRINCIPAL -->
        <div class="page-title">
          {{ title() }}
        </div>
      </div>

      <div class="topbar-right">
        <div class="date">{{ currentDate() }}</div>
        <div class="time">{{ currentTime() }}</div>
      </div>
    </header>

    <!-- MAIN PAGE -->
    <main class="page">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
